import styled from 'styled-components';

import ActionButton from 'components/action-button';

export { ActionLink as StyledSignUpToRedeemLink } from 'components/action-button';

export const StyledRedemptionButton = styled(ActionButton)`
  font-size: 18px;
  justify-content: center;
  height: 48px;
`;
